import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import LoadField from '../components/LoadField';
import MoneyField from '../components/MoneyField';
require(`../assets/${process.env.PAGE}/css/components/Summary.css`);
import axios from 'axios';

class JuncalSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {

            requested_amount: null,
            requested_quotas: null,
            total_amount: null,
            quota_amount: null,
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                this.setState({
                    requested_amount: data.requested_amount,
                    requested_quotas: data.requested_quotas,
                    quota_amount: data.quota_amount,
                });
            }
        );
    }

    render() {
        return (
            <div className="summary text-center">
                <FormattedHTMLMessage id="app.step_checkout" description="Checkout info"/>
                <div className="summary_details">
                    <Row className="summary_row summary_row_vertical_align requested_amount">
                    <moneyField/>
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_requested_amount"
                                                  description="Checkout requested amount"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.requested_amount && (<MoneyField decimals={2} >{ this.state.requested_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row quota_amount">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_quota_amount"
                                                  description="Checkout quota amount"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.quota_amount && (<MoneyField>{ this.state.quota_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row requested_quotas">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>
                            <FormattedHTMLMessage id="app.step_checkout_requested_quotas"
                                                  description="Checkout requested quotas"/>
                        </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                {this.state.requested_quotas}
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={12} md={12} lg={12}>
                            <FormattedHTMLMessage id="app.step_checkout_info" description="Checkout advice"/>
                        </Col>
                    </Row>
                </div>
                <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
            </div>
        );
    }
}

JuncalSummary.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default JuncalSummary;



/** WEBPACK FOOTER **
 ** ./src/components/JuncalSummary.js
 **/